// Modal: editar la ficha de calificación (4 campos, Cara B).
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionFichaModal = ({ prospectoId, initial = {}, onClose, onSaved }) => {
  const [form, setForm] = useState({
    ficha_con_quien_hablo:    initial.ficha_con_quien_hablo    || "",
    ficha_que_les_interesa:   initial.ficha_que_les_interesa   || "",
    ficha_a_quien_le_compran: initial.ficha_a_quien_le_compran || "",
    ficha_oportunidad:        initial.ficha_oportunidad        || "",
  });
  const [submitting, setSubmitting] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospectoId);
      Object.entries(form).forEach(([k, v]) => fd.append(k, v || ""));
      const r = await axios.post(`${BASE}/prospectos_ficha_guardar.php`, fd);
      if (r.data?.success) {
        toast.success("Ficha guardada");
        if (onSaved) onSaved(form);
      } else {
        toast.error(r.data?.mensaje || "Error al guardar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 6px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>Lo que sé de ellos</h2>
        <p style={{ margin: "0 0 18px", color: "#888", fontSize: 12 }}>
          Esta ficha vive en el prospecto. Es lo que vas aprendiendo a medida que hablás.
        </p>
        <form onSubmit={handleSubmit}>
          <Field label="Con quién hablo">
            <input style={inp} value={form.ficha_con_quien_hablo} onChange={set("ficha_con_quien_hablo")}
              placeholder="Martín, encargado de compras" autoFocus />
          </Field>
          <Field label="Qué les interesa">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.ficha_que_les_interesa} onChange={set("ficha_que_les_interesa")}
              placeholder="Cajas para exportación de ciruela, formato 5kg" />
          </Field>
          <Field label="A quién le compran hoy">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.ficha_a_quien_le_compran} onChange={set("ficha_a_quien_le_compran")}
              placeholder="Proveedor de Bs As. Se quejan de demoras." />
          </Field>
          <Field label="Oportunidad">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }}
              value={form.ficha_oportunidad} onChange={set("ficha_oportunidad")}
              placeholder="Arranca temporada en septiembre" />
          </Field>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>{submitting ? "Guardando…" : "Guardar ficha"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal   = { background: "#fff", borderRadius: 14, padding: 26, maxWidth: 560, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp     = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary   = { padding: "9px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "9px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

export default ProspeccionFichaModal;
